import * as React from "react";
import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";
import PageContainer from "./pageContainer.js";
import { when } from "../styles/theme.js";

const Container = styled.div`
  height: 70vh;
  position: relative;
  color: ${(props) => props.theme.colors.white};

  ${when("md")} {
    height: 50vh;
  }
`;

const BackgroundImage = styled(GatsbyImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const TitleContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 4.2rem;
  letter-spacing: 0.5rem;

  &:lang(en) {
    font-weight: 400;
    letter-spacing: 0.1rem;
  }
`;

const PageHeader = React.forwardRef(({ title, backgroundImage }, ref) => {
  return (
    <Container ref={ref}>
      <BackgroundImage
        alt={backgroundImage.description}
        image={backgroundImage.gatsbyImageData}
        objectFit={"cover"}
      />
      <TitleContainer>
        <PageContainer>
          <Title>{title}</Title>
        </PageContainer>
      </TitleContainer>
    </Container>
  );
});

export default PageHeader;
